import { render, staticRenderFns } from "./TOTP.vue?vue&type=template&id=a0706818&"
import script from "./TOTP.vue?vue&type=script&lang=ts&"
export * from "./TOTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports